import { createStyles, fade, makeStyles, Theme } from '@material-ui/core/styles';

import { colorsPalette, MIDDLE_MARGIN, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    imgLink: {
      display: 'block',
      height: '100%',
    },
    imgLinkWrapper: {
      flex: 1,
      marginBottom: SMALL_MARGIN,
      [theme.breakpoints.up('md')]: {
        marginBottom: 0,
      },
    },
    titleWrapper: {
      color: colorsPalette.white,
    },
    pathwayCard: {
      marginBottom: 0,
    },
    pathwayActionBlock: {
      marginBottom: MIDDLE_MARGIN,
      [theme.breakpoints.up('md')]: {
        marginBottom: 0,
      },
    },
    cardLabels: {
      '&:not(:only-child)': {
        marginRight: 10,
      },
    },
    labelsWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      flexWrap: 'wrap',
      '& $cpdLabel': {
        padding: '4.5px 9px',
      },
    },
    cpdLabel: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: SMALL_MARGIN,
    },
    cpdScore: {
      fontWeight: 'bold',
      color: colorsPalette.white,
      fontSize: 20,
      lineHeight: 1,
      [theme.breakpoints.up('xl')]: {
        marginRight: 9,
      },
    },
    cpdTitle: {
      display: 'none',
      color: colorsPalette.white,
      fontSize: 14,
      lineHeight: 1,
      whiteSpace: 'nowrap',
      [theme.breakpoints.up('xl')]: {
        display: 'block',
      },
    },
    imageWrapper: {
      height: '100%',
      marginBottom: 0,
    },
    imageBackground: {
      '&::after': {
        content: '""',
        display: 'block',
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        background: fade(colorsPalette.blueDark, 0.66),
      },
    },
    infoRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  }),
);

export default useStyles;
